var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShCalendar(props) {
  return React.createElement(
    "svg",
    _extends({
      "data-name": "calendar",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13.953 13.953"
    }, props),
    React.createElement("path", {
      "data-name": "Path 1615",
      d: "M12.154 1.09H10.9V.436a.436.436 0 00-.872 0v.654h-6.1V.436a.436.436 0 00-.872 0v.654H1.8A1.8 1.8 0 000 2.889v9.266a1.8 1.8 0 001.8 1.8h10.354a1.8 1.8 0 001.8-1.8V2.889a1.8 1.8 0 00-1.8-1.799zM1.8 1.962h1.252V2.4a.436.436 0 00.872 0v-.438h6.1V2.4a.436.436 0 00.872 0v-.438h1.254a.928.928 0 01.927.927v1.035H.872V2.889a.928.928 0 01.928-.927zm10.354 11.119H1.8a.928.928 0 01-.927-.927V4.8h12.208v7.358a.928.928 0 01-.927.923z"
    })
  );
}

export default SvgShCalendar;